'use strict';

var styled = require('styled-components');
var index = require('../Flex/index.js');
var styles$1 = require('../Anchor/styles.js');
var styles = require('../Text/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const FlexRow = styled__default.default(index.Flex.Row) `
  background: ${({ theme }) => theme.designTokens.headerNavSubItemBackgroundColor};
  padding: 0 ${({ theme }) => theme.designTokens.headerNavSubItemPaddingX};

  &:hover,
  &.hover,
  &:focus-within,
  &.focus-within {
    background: ${({ theme }) => theme.designTokens.headerNavSubItemHoverBackgroundColor};
  }

  ${styles.Styled} {
    flex: 1;
  }

  ${styles.Styled} > *:last-child {
    height: 100%;
    display: block;
    padding: ${({ theme }) => theme.designTokens.headerNavSubItemPaddingY} 0;
    line-height: ${({ theme }) => theme.designTokens.bodyLineHeight};
  }

  ${styles$1.Styled.Anchor} {
    color: inherit;
    text-decoration: none;
  }
`;
const Styled = {
    FlexRow,
    Text: styles.Styled,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
